module.exports = __webpack_public_path__ + "media/vo-02-02.8f4e0278.mp3";